/**
 * Manage global libraries like jQuery or THREE from the webpack.mix.js file
 */


// Import jQuery properly
import $ from 'jquery';
window.$ = window.jQuery = $;

// Import custom modules
import App from './modules/app.js';

// Import other dependencies
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const app = new App();